var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{domProps:{"textContent":_vm._s(_vm.firstName)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(_vm.lastName)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(_vm.phoneNumber)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(_vm.status)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(_vm.statusAt)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }